import { Injectable } from '@angular/core';
import { Model } from '@df/catalog/model';
import { App } from '@df/core/app';
import { RequestService } from './request/request.service';
import { Status } from '@df/core/status';
import { Client } from '@df/core/service/client';
import { Acl } from '@df/core/service/acl';

@Injectable({ providedIn: 'root' })
export class BackendService {
    constructor(
        private app: App,
        private requestService: RequestService,
        private acl: Acl
    ) {}

    /**
     * Retrieves link where we can edit given model
     */
    getEditUrl(model: Model): string | undefined {
        if (!this.app.data) {
            return undefined;
        }
        if (model.id) {
            switch (model.type) {
                case 'product':
                case 'category':
                    return `${this.app.dfConfig.endpoint.mage}/${this.app.data['admin_url'] || 'tcadmin'}/catalog/${model.type}/edit/id/${
                        model.id
                    }/`;
            }
        }
        return undefined;
    }

    getAuthUrl(): string {
        return `${this.app.dfConfig.endpoint.mage}/${this.app.data['admin_url'] || 'tcadmin'}${
            this.acl.isDeveloper ? '/admin/auth/tco' : ''
        }`;
    }

    sendReindexRequest(status: Status | undefined, model: Model): Promise<void> {
        return this.requestService.send(status, {
            path: 'indexer/reindex',
            data: { id: model.id, entity: model.type, family: true }
        });
    }
}
